module.exports = __webpack_public_path__ + "img/code.db6b7099.png";